<script setup>
import CommentBox from '../../../../Components/Comments/CommentBox'
import Content from '../../../../Components/Comments/Content'

defineProps({
	goldCall: Object,
	comments: Object,
})
</script>

<template>
	<div style="padding: 56.25% 0 0 0; position: relative">
		<iframe
			:src="`https://player.vimeo.com/video/${goldCall.video_id}`"
			style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
			frameborder="0"
			allow="autoplay; fullscreen; picture-in-picture"
			allowfullscreen
		/>
	</div>
	<!--  -->
	<div class="bg-body-dark">
		<div class="content content-full">
			<div class="row justify-content-center py-4">
				<div class="col-xl-10">
					<!-- <h3 class="fw-bold mb-5">Responses (5)</h3> -->
					<!-- Comments -->
					<Content
						v-for="comment in comments"
						:key="comment.id"
						:comment="comment"
					/>
					<!-- Comment box -->
					<CommentBox
						commentable-tbl="tbl_user_materials"
						:commentable-id="goldCall.id"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
